import ResourceViewmodel from "../../Resources/Viewmodels/ResourceViewmodel";

export default class SectionViewmodel {
    public id: number = 0;
    public name: string = '';
    public resourceType: string = '';
    public resources: ResourceViewmodel[] = [];
    public canEdit: boolean = false;
}